import { useMediaQuery } from "react-responsive";

export const useIsMobile = (): boolean => useMediaQuery({ maxWidth: 767 });

export const useIsSmallMobile = (): boolean => useMediaQuery({ maxWidth: 374 });
